import { render, staticRenderFns } from "./CreditScorePage.vue?vue&type=template&id=6c1da48c&scoped=true"
import script from "./CreditScorePage.vue?vue&type=script&lang=ts"
export * from "./CreditScorePage.vue?vue&type=script&lang=ts"
import style0 from "./CreditScorePage.vue?vue&type=style&index=0&id=6c1da48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1da48c",
  null
  
)

export default component.exports